import axios from 'axios';

const isLocal = window.location.hostname === 'localhost';
const api = axios.create({
  baseURL: isLocal ? 'http://localhost/crm_nancozi/backend_php' : '/backend_php',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = window.__CRM_ACCESS_TOKEN__ || localStorage.getItem('crm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, (error) => Promise.reject(error));

let isRefreshing = false;
let failedQueue  = [];
const processQueue = (error, token = null) => {
  failedQueue.forEach(p => error ? p.reject(error) : p.resolve(token));
  failedQueue = [];
};

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => failedQueue.push({ resolve, reject }))
          .then(token => { original.headers.Authorization = `Bearer ${token}`; return api(original); });
      }
      original._retry = true;
      isRefreshing = true;
      const rt = window.__CRM_REFRESH_TOKEN__ || localStorage.getItem('crm_refresh');
      if (!rt) { window.location.href = '/login'; return Promise.reject(error); }
      try {
        const { data } = await axios.post(`${api.defaults.baseURL}/auth/token/refresh/`, { refresh: rt });
        window.__CRM_ACCESS_TOKEN__ = data.access;
        localStorage.setItem('crm_token', data.access);
        api.defaults.headers.common['Authorization'] = `Bearer ${data.access}`;
        processQueue(null, data.access);
        original.headers.Authorization = `Bearer ${data.access}`;
        return api(original);
      } catch (err) {
        processQueue(err, null);
        localStorage.removeItem('crm_token');
        localStorage.removeItem('crm_refresh');
        localStorage.removeItem('crm_user');
        window.__CRM_ACCESS_TOKEN__ = null;
        window.__CRM_REFRESH_TOKEN__ = null;
        window.location.href = '/login';
        return Promise.reject(err);
      } finally { isRefreshing = false; }
    }
    return Promise.reject(error);
  }
);
export default api;
